/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="20.32"
        height="12.67"
        viewBox="0 0 20.32 12.67"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M2.7 2.62 0 5.25h17.05l2.77-2.63L17.05 0H0Zm15.67 0-1.72 1.63H2.46l1.68-1.63L2.47 1h14.18ZM3.13 7.33.38 10l2.71 2.62v.05h17.19L17.57 10l2.71-2.67Zm14.75 4.33H3.54L1.82 10l1.72-1.67h14.34L16.19 10Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'LeftRightDirectionalSignsIcon';

export default Icon;
